import React from 'react'
import { twMerge } from 'tailwind-merge'
import { isCustomDomain } from 'shared/utils/is-custom-domain'
import { addPublicCustomClassNamePrefix } from 'modules/course/utils/add-class-prefix'
import { AuthenticationLanguageSwitcher } from './components/authentication-language-switcher'

interface AuthenticationHeaderProps {
  logoSrc?: string
  className?: string
  languageSwitcherClassName?: string
  listLanguageSwitcherClassName?: string
  listLanguageSwitcherItemClassName?: string
  buttonLanguageSwitcherClassName?: string
  headerContainerClassName?: string
}

function AuthenticationHeader({
  logoSrc,
  className,
  languageSwitcherClassName,
  listLanguageSwitcherClassName,
  listLanguageSwitcherItemClassName,
  buttonLanguageSwitcherClassName,
  headerContainerClassName,
}: AuthenticationHeaderProps) {
  const hasCustomDomain = isCustomDomain()

  return (
    <>
      <nav
        className={twMerge(
          'top-0 z-20 py-10 font-avertaPE',
          !hasCustomDomain && 'mx-auto max-w-[1350px] py-5 md:py-8',
          className,
          addPublicCustomClassNamePrefix('header'),
        )}
      >
        <div
          className={twMerge(
            'z-10 mx-auto flex w-full items-center justify-between px-4 text-background-secondary sm:px-6',
            hasCustomDomain && 'md:px-14',
            headerContainerClassName,
          )}
        >
          <div className="flex items-center gap-5">
            {!hasCustomDomain && (
              <a href="/" className="flex items-center gap-1">
                <img
                  className={twMerge(
                    'max-h-[60px] max-w-[96px] md:max-w-[137px]',
                    addPublicCustomClassNamePrefix('header__logo__icon'),
                  )}
                  src={logoSrc}
                  alt="Logo"
                />
              </a>
            )}
          </div>
          <AuthenticationLanguageSwitcher
            className={twMerge('text-neutral-400', languageSwitcherClassName)}
            listClassName={listLanguageSwitcherClassName}
            listItemClassName={listLanguageSwitcherItemClassName}
            buttonClassName={buttonLanguageSwitcherClassName}
          />
        </div>
      </nav>
    </>
  )
}

export default AuthenticationHeader
